/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2025-04-18",
    versionChannel: "nightly",
    buildDate: "2025-04-18T00:06:43.398Z",
    commitHash: "afb8e53c2d4e93f9b70b6dc740d20e86c0059181",
};
